import * as Sentry from "@sentry/react";
import { SENTRY_DSN, APP_ENVIRONMENT } from "@/config/config.ts";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    environment: APP_ENVIRONMENT || "development",
    release: __SENTRY_RELEASE__,
  });
}

export function report(e: unknown, extra?: Record<string, unknown>) {
  Sentry.captureException(e, extra ? { extra } : undefined);
}
